/* lp-guards: page-scoped kill switches for third-party cart behaviour, chosen by the offer
   brand config (apps.guards, generated into window.lpGuardList by lp-guards-config). Named by app,
   never by brand. Loaded synchronously in <head> before content_for_header, so the trap is in
   place before any app script assigns its global (KB 3, 4.14). */
(function () {
  var guards = window.lpGuardList || [];
  var GUARDS = {
    'kaching-cart': function () {
      var strip = function (v) {
        if (v && typeof v === 'object') { v.tieredPromotionsBar = null; v.autoAtcRules = []; }
        return v;
      };
      var current = strip(window.__kachingCartProps);
      try {
        Object.defineProperty(window, '__kachingCartProps', {
          configurable: true,
          get: function () { return current; },
          set: function (v) { current = strip(v); }
        });
      } catch (e) {}
    }
  };
  // Email-capture popups (popup, flyout and the teaser tab) promote a site discount over a page whose
  // offer lives in the page itself. Hidden from the first paint; the app's scroll lock is released.
  GUARDS['klaviyo-forms'] = function () {
    var css = '[class*="kl-teaser-"],div.needsclick[role="dialog"][aria-label$=" Form"]{display:none!important}' +
              'body.klaviyo-prevent-body-scrolling{overflow:visible!important}';
    var st = document.createElement('style');
    st.setAttribute('data-lp-guard', 'klaviyo-forms');
    st.textContent = css;
    (document.head || document.documentElement).appendChild(st);
    var watch = function () {
      var b = document.body;
      if (!b) return;
      var release = function () { if (b.classList.contains('klaviyo-prevent-body-scrolling')) b.classList.remove('klaviyo-prevent-body-scrolling'); };
      release();
      try { new MutationObserver(release).observe(b, { attributes: true, attributeFilter: ['class'] }); } catch (e) {}
    };
    if (document.body) watch(); else document.addEventListener('DOMContentLoaded', watch);
  };

  guards.forEach(function (g) { if (GUARDS[g]) GUARDS[g](); });
  window.lpGuards = guards;
})();
